import "./links.css";
import PFP from "./../../components/images/PFPNew.png";
import RRLogoNoBK from "./../../components/images/RRLogoNoBK.png";
import OF from "./../../components/images/of.png";
import Fansly from "./../../components/images/fansly.png";
import { useState } from "react";

const LinksPage = () => {
    const [showAgeVerify, setShowAgeVerify] = useState(false);
    const [showAgeVerifyFansly, setShowAgeVerifyFansly] = useState(false);

    const openLink = (url, newTab = true) => {
        window.open(url, newTab ? "_blank" : "_self");
    };

    const openOnlyFansWarning = () => {
        setShowAgeVerify(true);
    };

    const closeOnlyFansWarning = () => {
        setShowAgeVerify(false);
    };

    const continueOnlyFans = () => {
        setShowAgeVerify(false);
        openLink("https://onlyfans.com/raerockhold");
    };

    const openFanslyWarning = () => {
        setShowAgeVerifyFansly(true);
    };

    const closeFanslyWarning = () => {
        setShowAgeVerifyFansly(false);
    };

    const continueFanslyDesktop = () => {
        setShowAgeVerifyFansly(false);
        openLink("https://fansly.com/raerockhold");
    };

    const continueFanslyMobile = () => {
        setShowAgeVerifyFansly(false);
        openLink("https://fansly.com/raerockhold", false);
    };

    return (
        <div>
            <div className="body-container">
                <div className="main-container">
                    <div className="inner-container">
                        <div className="logo">
                            <img src={RRLogoNoBK} alt="Logo" />
                        </div>

                        <div
                            className="ageVerify"
                            style={{ display: showAgeVerify ? "grid" : "none" }}
                        >
                            <h1>18+ Age Warning</h1>
                            <p>This link may contain content that is not appropriate for all audiences.</p>
                            <div>
                                <button className="declineButton" onClick={closeOnlyFansWarning}>
                                    Nevermind
                                </button>
                                <button className="acceptButton" onClick={continueOnlyFans}>
                                    Continue
                                </button>
                            </div>
                        </div>

                        <div
                            className="ageVerify"
                            style={{ display: showAgeVerifyFansly ? "grid" : "none" }}
                        >
                            <h1>18+ Age Warning</h1>
                            <p>This link may contain content that is not appropriate for all audiences.</p>
                            <div>
                                <button className="declineButton" onClick={closeFanslyWarning}>
                                    Nevermind
                                </button>
                                <button className="acceptButton" onClick={continueFanslyDesktop}>
                                    Continue
                                </button>
                            </div>
                        </div>

                        <div className="top-section">
                            <div className="profile-picture-outline">
                                <div className="profile-picture">
                                    <img src={PFP} alt="Rae Rockhold" />
                                </div>
                            </div>

                            <div className="Name">
                                <h1>Rae Rockhold</h1>
                            </div>

                            <div className="bio">
                                <p>Welcome to all things Rae &#9825;</p>
                            </div>

                            <div className="socials">
                                <div className="social-container2">
                                    <img src={OF} alt="OnlyFans" onClick={openOnlyFansWarning} />
                                </div>
                                <div className="social-container2">
                                    <img src={Fansly} alt="Fansly" onClick={openFanslyWarning} />
                                </div>
                            </div>
                        </div>

                        <div className="picture-link-section">
                            <div className="card-body">
                                <div
                                    className="card-inner-body"
                                    style={{
                                        backgroundImage:
                                            "url(https://raelinkimages.s3.us-west-1.amazonaws.com/OFImage.png)",
                                    }}
                                    onClick={openOnlyFansWarning}
                                >
                                    <h2>OnlyFans</h2>
                                </div>
                            </div>

                            <div className="card-body">
                                <div
                                    className="card-inner-body"
                                    style={{
                                        backgroundImage:
                                            "url(https://raelinkimages.s3.us-west-1.amazonaws.com/FanslyImg.png)",
                                    }}
                                    onClick={openFanslyWarning}
                                >
                                    <h2>Fansly</h2>
                                </div>
                            </div>
                        </div>

                        <div className="footer-section"></div>
                    </div>
                </div>
            </div>

            <div className="body-container-mobile">
                <div className="main-container-mobile">
                    <div className="inner-container">
                        <div className="logo">
                            <img src={RRLogoNoBK} alt="Logo" />
                        </div>

                        <div
                            className="ageVerify"
                            style={{ display: showAgeVerify ? "grid" : "none" }}
                        >
                            <h1>18+ Age Warning</h1>
                            <p>This link may contain content that is not appropriate for all audiences.</p>
                            <div>
                                <button className="declineButton" onClick={closeOnlyFansWarning}>
                                    Nevermind
                                </button>
                                <button className="acceptButton" onClick={continueOnlyFans}>
                                    Continue
                                </button>
                            </div>
                        </div>

                        <div
                            className="ageVerify"
                            style={{ display: showAgeVerifyFansly ? "grid" : "none" }}
                        >
                            <h1>18+ Age Warning</h1>
                            <p>This link may contain content that is not appropriate for all audiences.</p>
                            <div>
                                <button className="declineButton" onClick={closeFanslyWarning}>
                                    Nevermind
                                </button>
                                <button className="acceptButton" onClick={continueFanslyMobile}>
                                    Continue
                                </button>
                            </div>
                        </div>

                        <div className="top-section">
                            <div className="profile-picture-outline">
                                <div className="profile-picture">
                                    <img src={PFP} alt="Rae Rockhold" />
                                </div>
                            </div>

                            <div className="Name">
                                <h1>Rae Rockhold</h1>
                            </div>

                            <div className="bio">
                                <p>Welcome to all things Rae &#9825;</p>
                            </div>

                            <div className="socials">
                                <div className="social-container">
                                    <img src={OF} alt="OnlyFans" onClick={openOnlyFansWarning} />
                                </div>
                                <div className="social-container2">
                                    <img src={Fansly} alt="Fansly" onClick={openFanslyWarning} />
                                </div>
                            </div>
                        </div>

                        <div className="picture-link-section">
                            <div className="card-body">
                                <div
                                    className="card-inner-body"
                                    style={{
                                        backgroundImage:
                                            "url(https://raelinkimages.s3.us-west-1.amazonaws.com/OFImage.png)",
                                    }}
                                    onClick={openOnlyFansWarning}
                                >
                                    <h2>OnlyFans</h2>
                                </div>
                            </div>

                            <div className="card-body">
                                <div
                                    className="card-inner-body"
                                    style={{
                                        backgroundImage:
                                            "url(https://raelinkimages.s3.us-west-1.amazonaws.com/FanslyImg.png)",
                                    }}
                                    onClick={openFanslyWarning}
                                >
                                    <h2>Fansly</h2>
                                </div>
                            </div>
                        </div>

                        <div className="footer-section"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LinksPage;